const layzyMedia = document.querySelectorAll('img[lazy-load],source[lazy-load]');
const windowHeight = document.documentElement.clientHeight + 400;

let mediaPosition = [];
if(layzyMedia.length>0){
    layzyMedia.forEach(media=>{
        if(media.dataset.src){
            mediaPosition.push(media.getBoundingClientRect().top + pageYOffset);
            lazyScrollCheck();
        }
    })
}
window.addEventListener('scroll',lazyScroll);
document.addEventListener('DOMContentLoaded', function(){
    lazyScrollCheck();
});

function lazyScroll(){
    if(document.querySelectorAll('img[lazy-load],source[lazy-load]').length > 0){
        lazyScrollCheck();
    }
}
function lazyScrollCheck(){
    let mediaIndex = mediaPosition.findIndex(
        item=> pageYOffset > item - windowHeight
    )
    if(mediaIndex >=0){
        if(layzyMedia[mediaIndex].dataset.src){
            layzyMedia[mediaIndex].src = layzyMedia[mediaIndex].dataset.src;
            layzyMedia[mediaIndex].removeAttribute('data-src');
            if(layzyMedia[mediaIndex].tagName === 'SOURCE'){
                layzyMedia[mediaIndex].closest('video').load();
            }
        }

        delete layzyMedia[mediaIndex];
    }
}

function reloadLazyLoad(){
    let reloadLayzyMedia = document.querySelectorAll('img[lazy-load],source[lazy-load]');
    if(reloadLayzyMedia.length>0){
        reloadLayzyMedia.forEach(media=>{
            if(media.dataset.src){
                let mdeiaPosition = media.getBoundingClientRect().top + pageYOffset;
                if(pageYOffset > mdeiaPosition - windowHeight){
                    media.src = media.dataset.src;
                    media.removeAttribute('data-src');
                    if(media.tagName === 'SOURCE'){
                        media.closest('video').load();
                    }
                }
            }
        })
    }
}